import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import { EditMaxCLASkeleton } from './components/EditMaxCLASkeleton';

import useGetRowData from '../../hooks/useGetRowData';
import CreateEditMaxCLAForm from './CreateEditMaxCLAForm';

export default function CreateEditMaxCLA({
  handleClose,
  rowId
}: FormComponentProps) {
  const { isFetching, data } = useGetRowData(convertToNumber(rowId));

  return isFetching ? (
    <EditMaxCLASkeleton />
  ) : (
    <CreateEditMaxCLAForm handleClose={handleClose} rowData={data} />
  );
}
